<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:text-elm tw:animate-spin tw:inline-block", cls)} width="{width}" height="{height}"
     xmlns="http://www.w3.org/2000/svg" fill="none"
     viewBox="0 0 24 24">
    <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2.5"></circle>
    <path class="tw:opacity-75"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2.5"
          fill="none"
          d="M12 2 A 10 10 0 0 1 22 12">
    </path>
</svg>